import { LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';

import { registerLocaleData } from '@angular/common';

// Angular locales — register all supported EU languages
import localeEn from '@angular/common/locales/en';
import localePl from '@angular/common/locales/pl';
import localeDe from '@angular/common/locales/de';
import localeLt from '@angular/common/locales/lt';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import localeNl from '@angular/common/locales/nl';
import localeCs from '@angular/common/locales/cs';
import localeSk from '@angular/common/locales/sk';
import localeHu from '@angular/common/locales/hu';
import localeRo from '@angular/common/locales/ro';
import localeBg from '@angular/common/locales/bg';
import localeHr from '@angular/common/locales/hr';
import localeSl from '@angular/common/locales/sl';
import localeEl from '@angular/common/locales/el';
import localeEt from '@angular/common/locales/et';
import localeLv from '@angular/common/locales/lv';
import localeFi from '@angular/common/locales/fi';
import localeSv from '@angular/common/locales/sv';
import localeDa from '@angular/common/locales/da';
import localeMt from '@angular/common/locales/mt';

import { I18nHelper } from './i18n.helper';
import { LabelPipe } from './pipes/label.pipe';
import { FullDateTimePipe } from './pipes/full-datetime.pipe';
import { DaysUntilPipe } from './pipes/days-until';

// Register all Angular locale data
[
  localeEn, localePl, localeDe, localeLt,
  localeFr, localeEs, localeIt, localePt, localeNl,
  localeCs, localeSk, localeHu, localeRo, localeBg,
  localeHr, localeSl, localeEl, localeEt, localeLv,
  localeFi, localeSv, localeDa, localeMt,
].forEach(locale => registerLocaleData(locale));

@NgModule({
  declarations: [LabelPipe, FullDateTimePipe, DaysUntilPipe],
  exports: [LabelPipe, FullDateTimePipe, DaysUntilPipe],
})
export class TranslationsModule {
  static forRoot(): ModuleWithProviders<TranslationsModule> {
    return {
      ngModule: TranslationsModule,
      providers: [
        {
          provide: LOCALE_ID,
          deps: [I18nHelper],
          useFactory: (i18nHelper: I18nHelper) => {
            return i18nHelper.currentLang();
          }
        },
      ],
    };
  }
}
